exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orglist[data-v-02e7f7ad]{padding:0 12px;margin-bottom:25px}", ""]);

// exports
